import React from 'react';
import './style.css'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import FormControl from 'react-bootstrap/FormControl'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const NavBar = () => {
    
    const navBar = ['Home','Stack',]
    return(
      <>
        <header>
        <Navbar bg="white" expand="lg">
  <Navbar.Brand href="/home">              <a className="navbar-brand logo" href="#" ><img src="https://cin.ufpe.br/~mecls/img/logo.png" width="62" height="55" alt="logo maria estela souza"/></a>
</Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
    <Nav className="mr-auto  d-flex">
      <Nav.Link className="letter" href="/home">Home</Nav.Link>
      <Nav.Link className="letter" href="/stack">Stack</Nav.Link>
      <Nav.Link className="letter" target="_blank" href="https://mecls.medium.com/">Medium</Nav.Link>
     
    </Nav>
  
  </Navbar.Collapse>
</Navbar>


      </header>
      </>
    )}

export default NavBar